import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import { useRef } from 'react';
import { getChartOptions } from 'modules/iterableGoals/utils';
import { globalOpts } from 'modules/iterableGoals/constants/common';

import { MediumEnum, MediumMetric } from 'modules/iterableGoals/types';

import { ChartContent, ChartWrapper } from './Styled';

if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

Highcharts.setOptions(globalOpts);

type ContributionsByChannelProps = {
  contributionsData: [MediumEnum, MediumMetric, string][];
  totalContributions: number;
};

export const GoalContributionsByMediumChart = ({
  contributionsData,
  totalContributions,
}: ContributionsByChannelProps) => {
  const chartRef = useRef<HighchartsReact>(null);
  const options = getChartOptions(contributionsData);

  return (
    <ChartWrapper>
      <ChartContent>
        {totalContributions > 0 && (
          <HighchartsReact
            ref={chartRef}
            options={options}
            containerProps={{ style: { margin: '0', width: '100%' } }}
          />
        )}
      </ChartContent>
    </ChartWrapper>
  );
};
